import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Martín', 'Sofía', 'Lucía', 'Joaquín', 'Camila', 'Tomás', 'Florencia', 'Agustín', 'Valentina', 'Mateo', 'Julieta', 'Federico', 'Mariana', 'Diego', 'Paula'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Neuquén', 'Bahía Blanca', 'Bariloche', 'Paraná', 'Santa Fe', 'Resistencia', 'Posadas'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    time: 0
  });
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setPurchaseData({
        name: randomName,
        city: randomCity,
        time: randomTime
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 6000);
      const nextDelay = Math.floor(Math.random() * (25000 - 15000 + 1)) + 15000;
      timeoutId = setTimeout(showPopup, nextDelay);
    };
    timeoutId = setTimeout(showPopup, 5000);
    return () => clearTimeout(timeoutId);
  }, []);
  return <AnimatePresence data-id="element-125">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-[320px] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-xl sm:bottom-8 sm:left-8" data-id="element-126">
          {/* Green verified bar */}
          <div className="flex items-center justify-center gap-1.5 bg-emerald-500 px-3 py-1.5" data-id="element-127">
            <CheckCircle2 className="h-3.5 w-3.5 text-white" data-id="element-128" />
            <span className="text-[11px] font-black uppercase tracking-wider text-white" data-id="element-129">
              Compra Verificada
            </span>
          </div>

          {/* Body */}
          <div className="flex items-center gap-3 p-3" data-id="element-130">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-emerald-100" data-id="element-131">
              <CheckCircle2 className="h-6 w-6 text-emerald-600" data-id="element-132" />
            </div>
            <div className="min-w-0" data-id="element-133">
              <p className="text-sm text-slate-800 leading-snug" data-id="element-134">
                <motion.span animate={{
              opacity: [1, 0.4, 1]
            }} transition={{
              duration: 1.4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="font-bold text-emerald-700" data-id="element-135">
                  {purchaseData.name} de {purchaseData.city}
                </motion.span>{' '}
                acaba de comprar el KIT
              </p>
              <p className="mt-0.5 text-xs text-slate-500" data-id="element-136">
                hace {purchaseData.time} minutos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}